import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormlyModule } from '@ngx-formly/core';
import { MatButtonModule } from '@angular/material/button';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { AddNewLeadFormComponent } from './add-new-lead-form/add-new-lead-form.component';
import { AddMoreInfoLeadFormComponent } from './add-more-info-lead-form/add-more-info-lead-form.component';
import { MatInputModule } from '@angular/material/input';
import { AlertModule } from 'app/components/alert/alert.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AddNewLeadButtonComponent } from './add-new-lead-button/add-new-lead-button.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NgxMaskDirective } from 'ngx-mask';

function maxValidationMessage(err, field) {
  return `This value should be less than ${field.templateOptions.max}`;
}

@NgModule({
    declarations: [
        AddNewLeadFormComponent,
        AddMoreInfoLeadFormComponent,
        AddNewLeadButtonComponent,
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        FormlyModule.forChild({
            validationMessages: [
                {
                    name: 'max',
                    message: maxValidationMessage,
                }
            ]
        }),
        FormlyMaterialModule,
        MatStepperModule,
        MatAutocompleteModule,
        MatInputModule,
        AlertModule,
        MatProgressSpinnerModule,
        NgxMaskDirective,
    ],
    exports: [
        AddNewLeadButtonComponent,
        AddNewLeadFormComponent,
    ]
})
export class AddNewLeadModule { }
